import { useCallback, useState } from 'react';
import {
  ContentSearchType,
  DocumentEntity,
  useGetDocumentLazyQuery,
  useGetRegulationLazyQuery,
} from '@common/Providers/GraphqlProvider/generated';

export const useGetDocumentInfo = () => {
  const [documentData, setDocumentData] = useState<DocumentEntity | undefined>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [getDocument] = useGetDocumentLazyQuery();
  const [getRegulation] = useGetRegulationLazyQuery();

  const getDocumentInfo = useCallback(
    async (documentId: string, documentType: ContentSearchType) => {
      if (!documentId) return;

      try {
        setLoading(true);
        setError(null);

        let _doc: DocumentEntity | undefined;
        if (documentType === ContentSearchType.Regulation) {
          const response = await getRegulation({ variables: { regulationId: documentId } });
          _doc = response.data?.regulation as unknown as DocumentEntity;
        } else {
          const response = await getDocument({ variables: { documentId } });
          _doc = response.data?.document as DocumentEntity;
        }

        if (!_doc) {
          throw new Error('No se encontró información del documento');
        }

        setDocumentData(_doc);
        return _doc;
      } catch (err) {
        const errorMessage = err instanceof Error ? err.message : 'Error al obtener información';
        setError(errorMessage);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [getDocument, getRegulation]
  );

  return {
    getDocumentInfo,
    documentData,
    loading,
    error,
  };
};
